module.exports = __webpack_public_path__ + "static/img/banner-product.195c32e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/banner-product.jpg
// module id = F5xu
// module chunks = 1